import { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const GCC_CODES = [
  { code: '+966', flag: '\u{1F1F8}\u{1F1E6}', country: 'Saudi Arabia', countryAr: 'السعودية' },
  { code: '+971', flag: '\u{1F1E6}\u{1F1EA}', country: 'UAE', countryAr: 'الإمارات' },
  { code: '+974', flag: '\u{1F1F6}\u{1F1E6}', country: 'Qatar', countryAr: 'قطر' },
  { code: '+965', flag: '\u{1F1F0}\u{1F1FC}', country: 'Kuwait', countryAr: 'الكويت' },
  { code: '+973', flag: '\u{1F1E7}\u{1F1ED}', country: 'Bahrain', countryAr: 'البحرين' },
  { code: '+968', flag: '\u{1F1F4}\u{1F1F2}', country: 'Oman', countryAr: 'عُمان' },
];

const OTHER_CODES = [
  { code: '+90', flag: '\u{1F1F9}\u{1F1F7}', country: 'Turkey', countryAr: 'تركيا' },
  { code: '+1', flag: '\u{1F1FA}\u{1F1F8}', country: 'USA', countryAr: 'الولايات المتحدة' },
  { code: '+44', flag: '\u{1F1EC}\u{1F1E7}', country: 'UK', countryAr: 'المملكة المتحدة' },
  { code: '+49', flag: '\u{1F1E9}\u{1F1EA}', country: 'Germany', countryAr: 'ألمانيا' },
  { code: '+33', flag: '\u{1F1EB}\u{1F1F7}', country: 'France', countryAr: 'فرنسا' },
  { code: '+7', flag: '\u{1F1F7}\u{1F1FA}', country: 'Russia', countryAr: 'روسيا' },
  { code: '+20', flag: '\u{1F1EA}\u{1F1EC}', country: 'Egypt', countryAr: 'مصر' },
  { code: '+962', flag: '\u{1F1EF}\u{1F1F4}', country: 'Jordan', countryAr: 'الأردن' },
  { code: '+961', flag: '\u{1F1F1}\u{1F1E7}', country: 'Lebanon', countryAr: 'لبنان' },
  { code: '+964', flag: '\u{1F1EE}\u{1F1F6}', country: 'Iraq', countryAr: 'العراق' },
  { code: '+91', flag: '\u{1F1EE}\u{1F1F3}', country: 'India', countryAr: 'الهند' },
  { code: '+86', flag: '\u{1F1E8}\u{1F1F3}', country: 'China', countryAr: 'الصين' },
  { code: '+81', flag: '\u{1F1EF}\u{1F1F5}', country: 'Japan', countryAr: 'اليابان' },
];

const ALL_CODES = [...GCC_CODES, ...OTHER_CODES];

const texts = {
  en: {
    title: 'Request a Callback',
    subtitle: 'Leave your details and our team will call you back within 24 hours.',
    name: 'Full Name',
    phone: 'WhatsApp / Phone Number',
    email: 'Email Address',
    time: 'Preferred Callback Time',
    timeMorning: 'Morning (9AM - 12PM Istanbul)',
    timeAfternoon: 'Afternoon (12PM - 5PM Istanbul)',
    timeEvening: 'Evening (5PM - 9PM Istanbul)',
    timeSelect: 'Select preferred time',
    help: 'How can we help you?',
    helpPlaceholder: 'Tell us briefly what you need — tours, real estate, citizenship...',
    submit: 'Request Callback',
    submitting: 'Sending...',
    success: 'Thank you! We will call you back shortly.',
    error: 'Something went wrong. Please try again or message us on WhatsApp.',
  },
  ar: {
    title: 'اطلب معاودة الاتصال',
    subtitle: 'اترك بياناتك وسيتصل بك فريقنا خلال 24 ساعة.',
    name: 'الاسم الكامل',
    phone: 'رقم الواتساب / الهاتف',
    email: 'البريد الإلكتروني',
    time: 'وقت الاتصال المفضل',
    timeMorning: 'صباحاً (9 ص - 12 م بتوقيت إسطنبول)',
    timeAfternoon: 'بعد الظهر (12 م - 5 م بتوقيت إسطنبول)',
    timeEvening: 'مساءً (5 م - 9 م بتوقيت إسطنبول)',
    timeSelect: 'اختر الوقت المفضل',
    help: 'كيف يمكننا مساعدتك؟',
    helpPlaceholder: 'أخبرنا باختصار ما تحتاجه — جولات، عقارات، جنسية...',
    submit: 'اطلب معاودة الاتصال',
    submitting: 'جارٍ الإرسال...',
    success: 'شكراً لك! سنتصل بك قريباً.',
    error: 'حدث خطأ. يرجى المحاولة مرة أخرى أو مراسلتنا على واتساب.',
  },
  ru: {
    title: 'Заказать обратный звонок',
    subtitle: 'Оставьте свои данные, и наша команда перезвонит вам в течение 24 часов.',
    name: 'Полное имя',
    phone: 'WhatsApp / Телефон',
    email: 'Электронная почта',
    time: 'Предпочтительное время',
    timeMorning: 'Утро (9:00 - 12:00 по Стамбулу)',
    timeAfternoon: 'День (12:00 - 17:00 по Стамбулу)',
    timeEvening: 'Вечер (17:00 - 21:00 по Стамбулу)',
    timeSelect: 'Выберите время',
    help: 'Чем мы можем помочь?',
    helpPlaceholder: 'Кратко опишите — туры, недвижимость, гражданство...',
    submit: 'Заказать звонок',
    submitting: 'Отправка...',
    success: 'Спасибо! Мы перезвоним вам в ближайшее время.',
    error: 'Произошла ошибка. Попробуйте снова или напишите нам в WhatsApp.',
  },
  tr: {
    title: 'Geri Arama Talep Et',
    subtitle: 'Bilgilerinizi birakin, ekibimiz 24 saat icinde sizi arayacaktir.',
    name: 'Ad Soyad',
    phone: 'WhatsApp / Telefon',
    email: 'E-posta Adresi',
    time: 'Tercih Edilen Zaman',
    timeMorning: 'Sabah (09:00 - 12:00 Istanbul)',
    timeAfternoon: 'Ogle (12:00 - 17:00 Istanbul)',
    timeEvening: 'Aksam (17:00 - 21:00 Istanbul)',
    timeSelect: 'Zaman secin',
    help: 'Size nasil yardimci olabiliriz?',
    helpPlaceholder: 'Kisaca belirtin — turlar, emlak, vatandaslik...',
    submit: 'Geri Arama Talep Et',
    submitting: 'Gonderiliyor...',
    success: 'Tesekkurler! En kisa surede sizi arayacagiz.',
    error: 'Bir hata olustu. Tekrar deneyin veya WhatsApp ile yazin.',
  },
};

export function CallbackForm({ language, sourcePage }) {
  const isAr = language === 'ar';
  const tx = texts[language] || texts.en;
  const [form, setForm] = useState({ name: '', countryCode: '+966', phone: '', email: '', time: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const handleChange = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.email) return;
    setLoading(true);
    setMsg(null);
    try {
      await axios.post(`${API}/api/callback`, {
        name: form.name,
        phone: `${form.countryCode} ${form.phone}`,
        email: form.email,
        preferred_time: form.time,
        message: form.message,
        language,
        source_page: sourcePage || window.location.pathname
      });
      setMsg({ type: 'success', text: tx.success });
      setForm({ name: '', countryCode: '+966', phone: '', email: '', time: '', message: '' });
    } catch {
      setMsg({ type: 'error', text: tx.error });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="callback-form-wrap" dir={isAr ? 'rtl' : 'ltr'} data-testid="callback-form">
      <div className="cb-header">
        <i className="fas fa-phone-alt cb-icon"></i>
        <h3>{tx.title}</h3>
        <p>{tx.subtitle}</p>
      </div>
      <form onSubmit={handleSubmit} className="cb-form" data-testid="cb-form">
        <div className="cb-row">
          <input type="text" required value={form.name} onChange={e => handleChange('name', e.target.value)} placeholder={tx.name} className="cb-input" data-testid="cb-name" />
        </div>
        <div className="cb-row cb-phone-row">
          <select value={form.countryCode} onChange={e => handleChange('countryCode', e.target.value)} className="cb-select cb-cc" data-testid="cb-country-code" aria-label="Country code">
            {ALL_CODES.map(c => (
              <option key={c.code} value={c.code}>{c.flag} {c.code} {language === 'ar' ? c.countryAr : c.country}</option>
            ))}
          </select>
          <input type="tel" required value={form.phone} onChange={e => handleChange('phone', e.target.value)} placeholder={tx.phone} className="cb-input cb-phone" data-testid="cb-phone" />
        </div>
        <div className="cb-row">
          <input type="email" required value={form.email} onChange={e => handleChange('email', e.target.value)} placeholder={tx.email} className="cb-input" data-testid="cb-email" />
        </div>
        <div className="cb-row">
          <select value={form.time} onChange={e => handleChange('time', e.target.value)} className="cb-select" data-testid="cb-time" aria-label="Preferred callback time">
            <option value="">{tx.timeSelect}</option>
            <option value="morning">{tx.timeMorning}</option>
            <option value="afternoon">{tx.timeAfternoon}</option>
            <option value="evening">{tx.timeEvening}</option>
          </select>
        </div>
        <div className="cb-row">
          <textarea value={form.message} onChange={e => handleChange('message', e.target.value)} placeholder={tx.helpPlaceholder} className="cb-textarea" rows={3} data-testid="cb-message" />
        </div>
        <button type="submit" disabled={loading} className="cb-submit" data-testid="cb-submit">
          {loading ? tx.submitting : tx.submit}
        </button>
        {msg && <div className={`cb-msg cb-msg-${msg.type}`} data-testid="cb-msg">{msg.text}</div>}
      </form>
    </div>
  );
}
